import * as React from "react";
import { cn } from "../../lib/utils";

type Variant = "primary" | "secondary" | "tertiary" | "destructive" | "ghost";
type Size = "sm" | "md" | "lg";

const variantClasses: Record<Variant, string> = {
  primary:
    "bg-teal text-white hover:brightness-110 active:brightness-95 disabled:bg-teal/40",
  secondary:
    "bg-gold text-white hover:brightness-110 active:brightness-95 disabled:bg-gold/40",
  tertiary:
    "bg-surface-card border border-line text-ink-muted hover:bg-surface",
  destructive: "bg-transparent text-protein hover:bg-protein/10",
  ghost: "bg-transparent text-ink hover:bg-surface",
};

const sizeClasses: Record<Size, string> = {
  sm: "h-9 px-3 text-sm",
  md: "h-11 px-4 text-sm",
  lg: "h-12 px-5 text-sm",
};

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  fullWidth?: boolean;
  dataCy?: string;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      variant = "primary",
      size = "md",
      fullWidth = false,
      type = "button",
      dataCy,
      ...props
    },
    ref,
  ) => (
    <button
      ref={ref}
      type={type}
      data-cy={dataCy}
      className={cn(
        "inline-flex items-center justify-center rounded-card font-bold transition disabled:cursor-not-allowed",
        variantClasses[variant],
        sizeClasses[size],
        fullWidth && "w-full",
        className,
      )}
      {...props}
    />
  ),
);
Button.displayName = "Button";
